import { Navigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { useAppContext } from "../AppProviders";
import { useStorageMap } from "../storage/Storage";
import { useGetHasTasksOnlyQueue } from "../api/UsersApi";
import LoadingSpinner from "../shared-components/LoadingSpinner";
import LandingPageLogo from "./landingPageLogo";

const LandingPage = () => {
  const { user, permissions } = useAppContext();
  const { hasOnlyQueue, isLoadingHasOnlyQueue } = useGetHasTasksOnlyQueue();
  const { logout } = useAuth0();
  const { clearLocalStorageCachedValues } = useStorageMap();

  function appLogout() {
    clearLocalStorageCachedValues();
    logout({ returnTo: window.location.origin });
  }

  const isSSOlogin = !user?.sub?.includes("auth0");

  if (isSSOlogin && permissions?.length === 0) {
    return (
      <div className="flex flex-col justify-center items-center h-screen w-screen">
        <div className="flex justify-center items-center m-2">
          <LandingPageLogo />
        </div>
        <div className="text-gray-900 text-2xl text-center m-2 font-bold">
          <div>User is not yet authorized to use this application</div>
          <div className="text-center m-2 font-bold">
            Please contact your IT administrator to request access.
          </div>
        </div>
        <div>
          <button
            onClick={appLogout}
            className="bg-green-500 text-white py-2 px-4 rounded"
          >
            Logout
          </button>
        </div>
      </div>
    );
  }

  if (isLoadingHasOnlyQueue) {
    return (
      <div
        className="flex justify-center items-center h-screen w-screen"
        data-testid="skelly"
      >
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <Navigate to={hasOnlyQueue ? "/reports/enter_queue" : "/reports"} replace />
  );
};

export default LandingPage;
